import { Button } from 'components/core';
import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { CustomBucket } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { FilterRow } from './FilterRow';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';

const blank = (): CustomBucket => ({ label: '', when: { field: '', op: 'is', value: '', value2: '' } });

// Buckets you name yourself. Leave empty to use the data's own, such as 1 to 5 stars for ratings.
export const BucketsStep = ({ a, s, patch }: StepProps) => {
  const buckets = a.custom.buckets;
  const save = (next: CustomBucket[]) => patch({ custom: { ...a.custom, buckets: next } });
  const set = (i: number, next: Partial<CustomBucket>) => save(buckets.map((b, j) => (j === i ? { ...b, ...next } : b)));
  const own = s.buckets?.length ? `Left empty, this uses ${s.buckets.map((b) => b.label).join(', ')}.` : 'This data has no buckets of its own, so define at least two.';

  return (
    <BuilderSection title="Buckets" hint={`Each bucket is a name and a condition. A record goes into every bucket whose condition it meets. ${own}`}>
      {buckets.map((b, i) => (
        <div key={i} className="border rounded p-2 mb-2 bg-white">
          <TextBox value={b.label} placeholder="Bucket name, e.g. First attempt" onChange={(label) => set(i, { label })} />
          <div className="mt-1">
            <FilterRow filter={b.when} fields={fieldsOf(a.src)} onChange={(when) => set(i, { when })} />
          </div>
          <Button {...OUTLINE_SMALL} onClick={() => save(buckets.filter((_, j) => j !== i))}>
            Remove bucket
          </Button>
        </div>
      ))}
      <Button {...OUTLINE_SMALL} onClick={() => save([...buckets, blank()])}>
        Add a bucket
      </Button>
    </BuilderSection>
  );
};
